<template>
  <div id="app-root">
    <!-- Avoid flicker while loading -->
    <div v-if="!isLoaded" class="loading-container">
      <!-- optional spinner -->
    </div>

    <!-- Global Maintenance Screen -->
    <div v-else-if="isMaintenance" class="maintenance-container">
      <i class="fa fa-cogs fa-4x mb-4 text-muted"></i>
      <h1>Plataforma em manutenção</h1>
      <p>
        Estamos a realizar melhorias no sistema.<br />
        Por favor tente mais tarde.
      </p>
    </div>

    <!-- Normal App -->
    <router-view v-else />
  </div>
</template>

<script
  src="https://cdn.onesignal.com/sdks/web/v16/OneSignalSDK.page.js"
  defer
></script>

<script>
export default {
  name: "app",

  data() {
    return {
      isMaintenance: false,
      isLoaded: false,
    };
  },

  created() {
    this.fetchMaintenanceStatus();
  },

  methods: {
    fetchMaintenanceStatus() {
      this.axios
        .get("app/maintenance")
        .then((response) => {
          this.isMaintenance = Number(response.data.maintenance_enable) === 1;
        })
        .catch(() => {
          this.isMaintenance = false;
        })
        .finally(() => {
          this.isLoaded = true;
        });
    },
  },
};

window.OneSignalDeferred = window.OneSignalDeferred || [];
OneSignalDeferred.push(async function (OneSignal) {
  await OneSignal.init({
    appId: "79bd762f-9218-4c95-b5b3-da5e2551d2fe",
  });
});
</script>

<style lang="scss">
// CoreUI Icons Set
@import "~@coreui/icons/css/coreui-icons.min.css";
/* Import Font Awesome Icons Set */
$fa-font-path: "~font-awesome/fonts/";
@import "~font-awesome/scss/font-awesome.scss";
/* Import Simple Line Icons Set */
$simple-line-font-path: "~simple-line-icons/fonts/";
@import "~simple-line-icons/scss/simple-line-icons.scss";
/* Import Flag Icons Set */
@import "~flag-icon-css/css/flag-icon.min.css";
/* Import Bootstrap Vue Styles */
@import "~bootstrap-vue/dist/bootstrap-vue.css";
// Import Main styles for this application
@import "assets/scss/style";

.maintenance-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  text-align: center;
  padding: 20px;
}

.maintenance-container img {
  max-width: 220px;
  margin-bottom: 24px;
}

.loading-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
